export default "__VITE_ASSET__C1njBIz0__"